import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Plot from 'react-plotly.js';
import { ManRadioButtonGroup, ManRadioButton, ManText } from '@craft-design-system/core-components-react';
import useGraphRadio from '../../utils/useGraphRadio';
import Shimmer_graph from '../shimmer_graph';
import ifav from './ifav.png';
import energyComponentsTable from '../../assets/images/BBP_CBP_consumption.png';
import { Button, Popover, OverlayTrigger } from 'react-bootstrap';
import PopoverComponent from '../popover';
import { Card } from 'react-bootstrap';
import AverageDisplay from './Average_value';
import Zoom from '../Zoom';
import DownloadButtonComponent from '../DownloadButtonComponent';
import { useFilterContext } from '../FilterContext';

const Average_consumption_speed_class = ({ value }) => {
  const [Speed_Class_standstill_graph, set_Speed_Class_standstill_graph] = useState(null);
  const radio_query = useGraphRadio();
  const { filterdata } = useFilterContext();
  const { startDate, endDate } = filterdata || {};
  const [radio_buttons_test, set_Radio_values] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [downloadData, setDownloadData] = useState(null);
  const [avg_value, setAvg_value] = useState(null);

  const popover = (
    <Popover id="popover-basic" style={{ maxWidth: '800px' }}>
      <Popover.Body>
        <div dangerouslySetInnerHTML={{
          __html: `<b>Energy Consumption per Speed Class (CBP):</b> The energy consumption per speed class of battery generation CBP is displayed with its components. This KPI is split up among BBP and CBP because the available components of energy consumption differ among the battery generations.<br/><br/>
          
          <b>Available Components for BBP and CBP:</b><br/>
          <img src="${energyComponentsTable}" alt="Energy Consumption Components" style="width: 200%; max-width: 700px; margin: 10px 0;"/><br/>
          
          <b>Condition for standing:</b><br/>
          Sum of time where vehiclespeedclass_value_filled IN ('SC_STANDSTILL')<br/><br/>
          
          <b>Condition for driving:</b><br/>
          Sum of time where vehiclespeedclass_value_filled in respective speed classes<br/><br/>
          
          <b>Time series data:</b><br/>
          If multiple vehicles are selected average values are displayed. Days without data are not taken into account for the calculation.`
        }} />
      </Popover.Body>
    </Popover>
  );



  useEffect(() => {
    if (radio_buttons_test) {
      setIsLoading(true);
      radio_query({
        vins_short: [value.vin_short],
        radio_value: radio_buttons_test,
        columnname: 'Speed Class| Standstill',
        startDate,
        endDate
      }).then(data => {
        set_Speed_Class_standstill_graph(JSON.parse(data['jsonData']));
        setIsLoading(false);
      });
    }
  }, [radio_buttons_test]);

  // Initial fallback data
  useEffect(() => {
    if (value?.standstill_consumption) {
      try {
        set_Speed_Class_standstill_graph(JSON.parse(value.standstill_consumption));
      } catch (error) {
        console.error("Error parsing fallback standstill_consumption JSON", error);
      }
    }
  }, [value.standstill_consumption]);
  

  

  return (
    <Card className="card_ride">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
        <div style={{ flex: 1, textAlign: 'center' }}>
          <ManText className="card-title-text" variant="component-l" as="span" size="l">
            CBP Energy consumption per speed class (and while standing with engine turned on)
          </ManText>
        </div>
        <div style={{ flexShrink: 0, display: 'flex', alignItems: 'center', flexDirection: "row-reverse" }}>
          <OverlayTrigger trigger="hover" placement="left" overlay={popover}>
            <img className="man-logovv1" src={ifav}/>
          </OverlayTrigger>
          <Zoom
            chartData={Speed_Class_standstill_graph?.data}
            chartLayout={Speed_Class_standstill_graph?.layout}
            chartTitle="CBP Energy consumption per speed class"
          />
          <DownloadButtonComponent data={downloadData} fileName='speed_class_standstill_data.csv' />
        </div>
      </div>

      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '16px', marginBottom: '16px' }}>
        {/* Center: Radio buttons */}
        <ManRadioButtonGroup
          name="Speed Class| Standstill"
          onManChange={(e) => set_Radio_values({ [e.detail.name]: e.detail.value })}
          style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}
        >
          <ManRadioButton name="Speed Class| Standstill" label="Yesterday" value="Yesterday" checked />
          <ManRadioButton name="Speed Class| Standstill" label="Current month" value="Current month" />
          <ManRadioButton name="Speed Class| Standstill" label="Current year" value="Current year" />
        </ManRadioButtonGroup>
      </div>

      {isLoading ? (
        <Shimmer_graph />
      ) : (
        Speed_Class_standstill_graph && (
          <Plot
            data={Speed_Class_standstill_graph.data}
            layout={{
              ...Speed_Class_standstill_graph.layout,
              margin: { t: 10, r: 10, l: 50, b: 280 },
              legend: {
                ...Speed_Class_standstill_graph.layout.legend,
                orientation: 'h',
                x: 0.5,
                xanchor: 'center',
                y: -0.55,
                yanchor: 'top',
                bgcolor: 'rgba(255,255,255,0.8)',
                bordercolor: 'rgba(0,0,0,0)',
                borderwidth: 0
              },
              autosize: true,
              responsive: true,
            }}
            useResizeHandler={true}
            style={{ width: '100%', height: '480px' }}
          />
        )
      )}
    </Card>
  );
};

Average_consumption_speed_class.propTypes = {
  value: PropTypes.shape({
    vin_short: PropTypes.string.isRequired,
    standstill_consumption: PropTypes.string,
  }).isRequired,
};

export default Average_consumption_speed_class;